<template>
  <div class="testPaperWrap">
    <Header></Header>
    <div class="content_box">
      <main id="wrapMain">
        <Left v-show="isShowLeft"></Left>
        <Right v-show="isShowLeft" style="flex: 1;"></Right>
        <div v-if="!isShowLeft && isShow" class="paperIframeBox">
          <div class="paperIframe" :style="paperIframeStyle" ref="paperIframe">
            <iframe
              style="height: 100%; width: 100%"
              :src="paperIframe"
            ></iframe>

            <div class="paperIframe_mask" v-show="isDrag"></div>
          </div>

          <div
            class="paperDrapLine"
            @mousedown.stop="iframeLineMove($event)"
            v-show="childrenShow"
          ></div>
          <div class="childrenIframe" v-show="childrenShow">
            <iframe
              style="height: 100%; width: 100%"
              :src="childrenIframe"
            ></iframe>
            <div class="paperIframe_mask" v-show="isDrag"></div>
            <span
              @click="closeChildIfamre"
              class="el-icon-circle-close paperChildClose"
            ></span>
          </div>
        </div>
      </main>
      <div id="frame" class="paperIrameTools" v-if="isShowIframe">
        <div class="top">
          <div class="right">
            <span style="float: left; margin-top: 5px">布局：</span>
            <el-radio-group
              @change="layoutChange"
              style="float: left"
              v-model="layout"
            >
              <el-radio-button label="上下"></el-radio-button>
              <el-radio-button label="左右"></el-radio-button>
            </el-radio-group>
            <span style="float: left; margin-top: 5px; margin-left: 10px"
            >分屏：</span
            >
            <el-radio-group
              @change="splited"
              style="float: left"
              v-model="split"
            >
              <el-radio-button label="3:1"></el-radio-button>
              <el-radio-button label="2:1"></el-radio-button>
              <el-radio-button label="1:1"></el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="peperChildrenEventBtn">
          <!--   子模板的按钮展示   -->
          <template v-if="childrenUrls.length">
            <span
              style="margin: 5px"
              v-for="(childItem, childIndex) in childrenUrls"
              :key="childIndex + 'child'"
              v-bury="{ start: true }"
              @click="peperChildrenEvent(childItem)"
              class="zl_button zl_blueButton"
            >
              {{ buttonName[childItem.platform] || childItem.platform }}
            </span>
          </template>
        </div>
        <div
          class=" editorShowArea ql-editor"
          v-html="questionData.questionDto.questionContent"
        ></div>
        <div class="questionEnclosure">
          <ul class="enclosureUl" v-show="enclosureUlShow">
            <li
              v-for="(item, index) in questionEnclosure"
              :key="index"
              class="questionEnclosureItem"
            >
              <span
                :title="item.name"
                @click="handlePreview(item.newAttaUrl)"
                class="enclosurePopoverLabel"
              >{{ item.name }}</span
              >
              <span
                class="el-icon-download enclosureDown"
                @click="handleImport(item.id)"
              ></span>
            </li>
          </ul>
          <div
            class="questionEnclosureStyle"
            v-show="questionEnclosure.length && !enclosureUlShow"
            @dblclick="dblclick"
            @click="openQuestionEnclosure"
          >
            <span class="el-icon-paperclip"></span>
            <span style="padding-right: 10px; padding-left: 3px">附件</span>
            <span class="number">{{ questionEnclosure.length }}</span>
          </div>
          <div v-show="questionEnclosure.length && enclosureUlShow" class="questionEnclosureStyle">
            <span></span>
            <span
              style="color: #d2d2d7"
              class="el-icon-close"
              @click="enclosureUlShow = false"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 预览试题上的附件 -->
    <el-dialog :visible.sync="filePreviewDialog" append-to-body destroy-on-close width="80%" top="7%">
      <iframe
        style="width: 100%;"
        :style="{height: windowHeight/6*4 + 'px'}"
        :src="filePreviewUrl"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
  import Header from "../testComponent/header";
  import Right from "../testComponent/ExamRight";
  import Left from "../testComponent/examLeft";

  export default {
    name: "testPaper",
    data() {
      return {
        windowHeight: window.innerHeight, // 窗口高度。
        //
        // iframeAddress: "", // IT工具
        // showRightType: "",
        // questionAnswer: "",
        // questionId: "",
        // taskData: "",
        // itAnswer: '',
        // leftWidth: "",
        // openRight: false,
        isDrag: false,
        // codeRefresh: 0, // 刷新
        // leftDivStyle: {width: "100%"},
        // rightDivStyle: {},
        // isLab: "1",
        // part1: null,
        // part2: null,
        // part3: null,
        // wjl  2022.5.24
        paperIframeStyle: {height: "100%"},
        iframeHeight: "60%",
        childrenShow: false,
        paperIframe: null,
        childrenIframe: null,
        childIframePlatform: "",
        // iframeLoading: true,
        //
        layout: "左右",
        split: "2:1",
        spliteType: true,
        isShow: false,
        // 试题中的附件预览
        filePreviewUrl: "", // 预览附件
        filePreviewDialog: false, // 弹窗
        questionEnclosure: [],
        enclosureUlShow: false,
        //  子事项
        childrenUrls: [],
        buttonName: {
          // professional == 1  智能审计
          auditExcel: '智能审计', // 开始练习
          // professional == 2   智能财税
          ctx: '财天下',
          ptx: '票天下',
          jss: '金税师',
          gxl: '供应链',
          shanglv: '商旅',
          dummy: '政务仿真',
          JiXiaoOS: '绩效管理',
          'basicdata': '运营中心',
          'budget': '数字管理会计',
          'dataAsset': '数据资产',
          'imagecenter': '影像中心',
          'reimburse': '报账中心',
          'settlement': '结算中心',
          'journal': '会计核算',
          'bill': '票据管理',
          'asset': '资产管理',
          'salary': '薪资管理',
          archives: '档案中心',
          cashier: '出纳中心',
          cost: '成本中心',
          'travel': '差旅费控',
          'purchase': '采购管理',
          'sale': '销售管理',
          'inventory': '库存管理',
          'tax': '金税师',
          'ToJss': '金税师',
          'ToTax': '金税师',
          // professional == 3  智能估值
          mgy: '摩估云',
          middleMGY: '摩估云中级',
          gzyy: '估值应用',
          // professional == 8   社交电商
          ECommerce: '电商实训',
          dummyPro: '电商调研',
          // professional == 24  三资
          zhcx: '综合查询',
          zcgl: '资产管理',
          zygl: '资源管理',
          zjbz: '资金报账',
          kjhs: '会计核算',
          dagl: '档案管理',
          // 补充
          BigDataOS: "大数据",
          ExcelOS: "答题板",
          ExcelCustomOS: "答题板",
          FZBAOSHUI: "仿真报税",
          ChinaGovTaxApply: "电子税务局",
          "ChinaGovTaxApply2.0": "电子税务局",
          "ZLBigData2.0": "中联大数据",
          managementAccount: "管理会计",
        },
      };
    },
    created() {},
    mounted() {},
    computed: {
      ...mapState('exam', {
        isShowIframe: (state) => state.isShowIframe,
        iframeUrl: (state) => state.iframeUrl,
        // sign: (state) => state.sign,
        // paperData: (state) => state.paperData,
        questionData: (state) => state.questionData,
        isShowLeft: (state) => state.isShowLeft,
      }),
    },
    components: {
      Header: Header,
      Left: Left,
      Right: Right
    },
    watch: {
      isShowIframe(val) {
        if (val) {
          this.layout = "左右";
          this.spliteType = true;
          this.split = "3:1";
          this.layoutChange(this.layout)
        }
      },
      iframeUrl(newVal) {
        this.isShow = false;
        if (newVal.url === "ISIT") {
          this.openRight = false;
          this.$nextTick(() => {
            this.go_coder(newVal);
          });
        } else {
          this.paperIframe = newVal.url;
          this.closeChildIfamre();
          this.childrenUrls = sessionStorage.getItem("childrenUrls")
            ? JSON.parse(sessionStorage.getItem("childrenUrls"))
            : [];
          this.questionEnclosure = sessionStorage.getItem("questionEnclosure")
            ? JSON.parse(sessionStorage.getItem("questionEnclosure"))
            : [];
          this.$nextTick(() => {
            this.isShow = true;
          });
        }
      },
    },
    methods: {
      ...mapMutations('exam', ["SHOW_OPTIONS", "SHOW_BACK", "SHOW_LEFT"]),
      ...mapActions('exam', ['saveAnswer']),

      layoutChange(val) {
        if (val === "上下") {
          $(".content_box").css("flex-direction", "column");
          $("#wrapMain").css("height", "75%");
          $("#wrapMain").css("width", "100%");
          $("#frame").css("width", "100%");
          $("#frame").css("height", "25%");
          this.spliteType = false;
          this.split = "3:1";
        } else if (val === "左右") {
          this.spliteType = true;
          this.split = "3:1";
          $(".content_box").css("flex-direction", "row");
          $("#wrapMain").css("height", "100%");
          $("#wrapMain").css("width", "75%");
          $("#frame").css("width", "25%");
          $("#frame").css("height", "100%");
        }
      },
      splited(val) {
        if (this.spliteType === false) {
          $("#wrapMain").css("width", "100%");
          $("#frame").css("width", "100%");
          if (val === "3:1") {
            $("#wrapMain").css("height", "75%");
            $("#frame").css("height", "25%");
          } else if (val === "2:1") {
            $("#wrapMain").css("height", "65%");
            $("#frame").css("height", "35%");
          } else if (val === "1:1") {
            $("#wrapMain").css("height", "50%");
            $("#frame").css("height", "50%");
          }
        } else {
          if (val === "3:1") {
            $("#wrapMain").css("width", "75%");
            $("#frame").css("width", "25%");
          } else if (val === "2:1") {
            $("#wrapMain").css("width", "65%");
            $("#frame").css("width", "35%");
          } else if (val === "1:1") {
            $("#wrapMain").css("width", "50%");
            $("#frame").css("width", "50%");
          }
        }
      },
      peperChildrenEvent(childItem) {
        if (childItem.platform === "BigDataOS") {
          window.open(childItem.childIframeUrl);
        }else if (childItem.platform === "RPAOS") {
          this.gonoRPA(childItem)
        } else {
          this.$set(this.paperIframeStyle, "height", this.iframeHeight);
          this.childrenIframe = childItem.childIframeUrl;
          this.childIframePlatform = childItem.platform;
          this.childrenShow = true;
        }
      },
      closeChildIfamre() {
        this.childrenShow = false;
        this.$set(this.paperIframeStyle, "height", "100%");
      },

      //============================启动RPA===========================
      gonoRPA(data) {
          window.protocolCheck(
            data.childIframeUrl,
            function () {
              var answer = confirm("检测到未安装编辑器，是否下载？");
              if (answer) {
                window.location = "https://zledu-static.oss-cn-beijing.aliyuncs.com/tools/study/Encoo.Studio.Setup.exe";
              } else {
                alert("已取消下载编辑器，无法启动。");
              }
            }
          );
      },

      /** 轴挪动 */
      iframeLineMove(ev) {
        let that = this;
        let screenY = ev.screenY;
        let refHeight = that.$refs.paperIframe.offsetHeight;
        that.isDrag = true;
        document.onmousemove = (e) => {
          window.event.preventDefault(); //
          window.event.cancelBubble = true; //IE
          let height = e.screenY - screenY + refHeight;
          that.$set(that.paperIframeStyle, "height", height + "px");
          that.iframeHeight = height + "px";
          that.$forceUpdate();
        };
        document.onmouseup = function () {
          document.onmousemove = null;
          that.isDrag = false;
        };
      },
      dblclick() {
      },
      openQuestionEnclosure() {
        this.enclosureUlShow = true;
      },
      handlePreview(url) {
        if(process.env.NODE_ENV === 'native' || url.search("html") != -1){
          this.filePreviewUrl = url;
        }else{
          this.filePreviewUrl = process.env.PREVIEW_URL + url;
        }
        this.filePreviewDialog = true;
      },
      // 选中导入的文件，传给组件
      handleImport(val) {
        let url = `${process.env.UPLOAD_NAME}/file/downloadFiles?id=` + val;
        this.$downloadFun(url)
      },
      // getITAnswer(itAnswer) {
      //   this.itAnswer = itAnswer;
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .testPaperWrap {
    width: 100%;
    height: 100%;

    .content_box {
      overflow: auto;
      width: 100%;
      height: calc(100% - 60px);
      display: flex;
      flex-direction: column;

      main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        position: relative;
        transition: all 1s;

        .paperIframeBox {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;

          // 主页面跳转，主页面展示
          .paperIframe {
            width: 100%;
            position: relative;
          }

          // 拖拽线
          .paperDrapLine {
            height: 5px;
            background: #cccccc;
            cursor: ns-resize;
          }

          // 子页面跳转，子页面展示
          .childrenIframe {
            width: 100%;
            position: relative;
            flex: 1;

            &:hover .paperChildClose {
              display: block;
            }
          }

          // 蒙层
          .paperIframe_mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 20000;
          }

          .paperChildClose {
            position: absolute;
            top: 5px;
            right: 5px;
            font-size: 20px;
            font-weight: 600;
            cursor: pointer;
            display: none;
          }
        }

        .foot {
          position: absolute;
          left: 45%;
          bottom: -12px;
          display: flex;
          flex-direction: row;

          .pre_btn {
            width: 65px;
            height: 20px;
            border-radius: 3px;
            display: block;
            background: rgba(83, 151, 247, 1);
            opacity: 0.5;
            cursor: pointer;
            text-align: center;
            line-height: 20px;
            font-size: 15px;

            &:hover {
              opacity: 1;
            }

            i {
              color: white;
            }
          }

          .btn {
            width: 65px;
            height: 20px;
            border-radius: 3px;
            display: block;
            background: rgba(83, 151, 247, 1);
            opacity: 0.5;
            cursor: pointer;
            text-align: center;
            line-height: 20px;
            margin-left: 20px;
            color: white;

            &:hover {
              opacity: 1;
            }

            i {
              color: white;
            }
          }

          .next_btn {
            width: 65px;
            height: 20px;
            border-radius: 3px;
            font-size: 15px;
            display: block;
            background: rgba(83, 151, 247, 1);
            opacity: 0.5;
            cursor: pointer;
            text-align: center;
            line-height: 20px;
            margin-left: 20px;

            &:hover {
              opacity: 1;
            }

            i {
              color: white;
            }
          }
        }

        .foot_left {
          position: absolute;
          top: 45%;
          right: 0;
          display: flex;
          flex-direction: column;

          .pre_btn {
            width: 17px;
            height: 50px;
            line-height: 50px;
            border-radius: 3px;
            display: block;
            background: rgba(83, 151, 247, 1);
            opacity: 0.5;
            cursor: pointer;
            text-align: center;
            font-size: 15px;

            &:hover {
              opacity: 1;
            }

            i {
              color: white;
            }
          }

          .btn {
            width: 17px;
            height: 50px;
            border-radius: 3px;
            display: block;
            background: rgba(83, 151, 247, 1);
            opacity: 0.5;
            cursor: pointer;
            text-align: center;
            line-height: 30px;
            margin-top: 20px;

            p {
              width: 100%;
              height: 15px;
              color: white;
            }

            &:hover {
              opacity: 1;
            }

            i {
              color: white;
            }
          }

          .next_btn {
            width: 17px;
            height: 50px;
            border-radius: 3px;
            font-size: 15px;
            display: block;
            background: rgba(83, 151, 247, 1);
            opacity: 0.5;
            cursor: pointer;
            text-align: center;
            line-height: 50px;
            margin-top: 20px;

            &:hover {
              opacity: 1;
            }

            i {
              color: white;
            }
          }
        }
      }

      .paperIrameTools {
        display: flex;
        flex-direction: column;
        width: 100%;
        /*height: 40%;*/
        /*margin-top: 20px;*/
        flex: 1;
        position: relative;

        .ql-editor > img {
          width: 100%;
        }

        .top {
          width: 100%;
          height: 40px;
          background: rgba(83, 151, 247, 0.1);

          .right {
            position: absolute;
            right: 0;
            padding-top: 10px;
            min-width: 300px;

            /deep/ .el-radio-group {
              height: 24px;

              .el-radio-button__inner {
                padding: 4px 10px;
                font-size: 12px;
              }
            }
          }
        }

        .ql-editor {
          width: 100%;
          flex: 1;
          overflow-y: auto;
        }
      }

      #dialog {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.4);

        .content {
          width: 550px;
          height: 320px;
          background: white;
          opacity: 1;
          z-index: 99;
          border-radius: 8px;
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          -o-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);

          .top {
            width: 100%;
            height: 40px;
            background: rgba(255, 190, 47, 1);
            opacity: 1;
            border-radius: 8px 8px 0px 0px;
          }

          .main {
            width: 70%;
            margin: 50px auto 0;
            height: 50px;

            i {
              font-size: 40px;
              color: rgba(255, 190, 47, 1);
              float: left;
            }

            span {
              float: left;
              font-size: 14px;
              width: 302px;
              height: 40px;
              display: inline-block;
              line-height: 40px;
              margin-left: 10px;
            }
          }

          h1 {
            font-size: 60px;
            color: rgba(239, 83, 83, 1);
            text-align: center;
          }

          .btn {
            width: 104px;
            height: 34px;
            text-align: center;
            line-height: 34px;
            border: 1px solid rgba(83, 151, 247, 1);
            opacity: 1;
            border-radius: 17px;
            color: rgba(83, 151, 247, 1);
            margin: 25px auto 0;
            cursor: pointer;
          }
        }
      }

      .peperChildrenEventBtn {
        text-align: right;
      }

      .questionEnclosure {
        background: #ffffff;
        position: absolute;
        bottom: 25px;
        right: 30px;
        border-radius: 6px;
        box-shadow: 0px 0px 4px 0px rgba(24, 144, 255, 0.3);
        z-index: 10;

        .questionEnclosureStyle {
          color: #1890ff;
          height: 28px;
          padding: 0px 8px;
          display: flex;
          align-items: center;
          cursor: pointer;
          justify-content: space-between;

          .number {
            background: #1890ff;
            color: #ffffff;
            display: inline-block;
            height: 16px;
            width: 16px;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            border-radius: 16px;
          }
        }

        .enclosureUl {
          max-height: 300px;
          overflow: auto;
        }

        .questionEnclosureItem {
          height: 36px;
          cursor: pointer;
          display: flex;
          align-items: center;
          position: relative;
          padding-left: 12px;
          padding-right: 40px;

          &:hover {
            background: rgba(24, 144, 255, 0.04);
            color: #1890ff;

            .enclosureDown {
              display: block;
            }
          }
        }

        .enclosurePopoverLabel {
          display: inline-block;
          width: 260px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          padding: 5px 0;
          font-size: 12px;
          color: #595964;
          vertical-align: -0.15em;
        }

        .enclosureDown {
          position: absolute;
          right: 12px;
          top: 7px;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          font-size: 16px;
          text-align: center;
          line-height: 24px;
          display: none;

          &:hover {
            background: #1890ff;
            color: #ffffff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testing/testPaper.vue